import logoUrl from "@/assets/sun-rental-logo.jpg";

interface Props {
  size?: number;
  className?: string;
}

/**
 * Sun Rental brand mark — uses the official red sun graphic.
 * Square aspect; render at any size from 24px (nav) to 96px+ (hero).
 */
export function SunLogo({ size = 28, className = "" }: Props) {
  return (
    <img
      src={logoUrl}
      width={size}
      height={size}
      alt="Sun Rental"
      className={className}
      style={{ objectFit: "contain", display: "inline-block" }}
    />
  );
}
